import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { HOME_PAGE } from "../config/global";

export default function RequireGuest() {
    const auth = useAuth();
    return auth && auth.user ? <Navigate to={HOME_PAGE}/> : <Outlet />;
}

